<template>
    <div>
        <h1 class="mb-4 font-active">free shipping</h1>
        <p>We offer FREE shipping worldwide for all our orders. To make your Friendly Diamonds experience as hassle-free as possible, we also offer FREE return shipping on all orders from the United States. </p>

        <h3>Shipping Timeline</h3>
        <p>Friendly Diamonds is committed to the timely delivery of your order. However, unforeseen circumstances such as inclement weather, carrier delays, or inaccurate addresses may affect the delivery period, causing constraints in rare cases. The estimated shipment date is the date when your order will be dispatched from our New York-based shipping office. It does not include any additional time required by the delivery partner for conveyance or local customs to complete the delivery process for international orders. All our orders are consigned via 2 business-day shipments. All loose diamond orders are typically dispatched within 2 to 10 days from the order date. All made-to-order items are dispatched within 2 to 3 weeks from the order date.</p>


        <h3>Delivery Partners</h3>
        <p>We use trusted delivery companies such as FedEx, UPS, and USPS for all our shipments. An alternative shipping method may be used when appropriate to reach your target destination and delivery date.</p>

        <h3>Safety Precautions & Insurance</h3>
        <p>For your protection, Friendly Diamonds always insures all items for their total value. All the shipments require an adult signature at the delivery destination. You will receive an email confirmation once your order is shipped by us. We do not ship to P.O. boxes, APOs, and FPOs to ensure full safety of your package.</p>

        <h3>Custom Charges And Duties</h3>
        <p>For all international shipments, customs processes and import duties are the customer's responsibility; please check with your local customs office for information.</p>

        <h3>Track Your Order</h3>
        <p>We make it easy for you to know how soon you can expect the delivery of your product. All orders are scheduled to ship on or before the expected shipment date shown in the order confirmation. Once your order is shipped, you will receive an email confirmation with the tracking information.</p>

        <h3>Special Deliveries </h3>
        <p>If your Friendly Diamonds purchase is meant to be a gift for someone and you want us to keep it a surprise, or you cannot be home to receive the package, we can make special arrangements for you. A Saturday delivery can be arranged for eligible locations for an additional $30. We can also hold the package for up to 7 days at a local FedEx station rather than having it delivered to your residence/business. </p>
    </div>
</template>

<script setup>
    
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color:#606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }

    p{
        font-size: 14px;
    }
}
</style>